import { createCrudApi } from '@core/api/createCrudApi';
import type { BaseEntity } from '@core/interfaces';

export interface Diocese extends BaseEntity {
  name: string;
  archdiocese?: Diocese | null;
}

export interface CreateDioceseData {
  name: string;
  archdiocese?: number | null;
}

export type UpdateDioceseData = Partial<CreateDioceseData>;

const dioceseApi = createCrudApi<Diocese, CreateDioceseData, UpdateDioceseData>(
  'diocese'
);

export const getAllDioceses = dioceseApi.getAll;
export const getDioceseById = dioceseApi.getById;
export const createDiocese = dioceseApi.create;
export const updateDiocese = dioceseApi.update;
export const deleteDiocese = dioceseApi.delete;
